"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveModuleDeactivations = resolveModuleDeactivations;
const resolveBindingsDeactivations_1 = require("./resolveBindingsDeactivations");
function resolveModuleDeactivations(params, moduleId) {
    const bindings = params.getBindingsFromModule(moduleId);
    return (0, resolveBindingsDeactivations_1.resolveBindingsDeactivations)(params, bindings);
}
//# sourceMappingURL=resolveModuleDeactivations.js.map